import { ElementDto, SceneTypeDto } from "@repo/api/overlays";
import { AbsoluteFill } from "remotion";
import { AssetMediaAsyncDto } from "@repo/api/asset-media";
import { ElementTiming } from "../../utils/timing.ts";
import { studioGlobals } from "../../utils/studio-globals.ts";
import { Element } from "./Element.tsx";

type Props = {
  elements: ElementDto[];
  elementTimings: Record<string, ElementTiming | null>;
  assetMedias: Record<string, AssetMediaAsyncDto>;
  sceneType: SceneTypeDto;
  isPlaying: boolean;
};

export default function ElementsLayer({
  elements,
  elementTimings,
  assetMedias,
  sceneType,
  isPlaying,
}: Props) {
  const reversedElements = [...elements].reverse();

  return (
    <AbsoluteFill>
      {reversedElements.map((element) => {
        const props = {
          element,
          elementTiming: elementTimings[element.externalId] ?? null,
          assetMedias,
          sceneType,
        };

        if (studioGlobals.Element !== null && !isPlaying) {
          return <studioGlobals.Element key={element.externalId} {...props} />;
        }

        return <Element key={element.externalId} {...props} />;
      })}
    </AbsoluteFill>
  );
}
